/*
  Pouch Store: cart drawer conversion layer (23 Oct 2026)
  Markup lives in snippets/ps-cart-cro.liquid. This file:
  - adds gap-closer and "Complete your order" items without a page reload
  - sets the checkout button to the total including delivery
  - shows line totals ("£8.97 / £2.99 each") when quantity > 1
*/
(function () {
  if (window.psCartCro) return;
  window.psCartCro = true;

  function money(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function sectionsToRender() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  function addToCart(variantId, qty, button) {
    var label = button ? button.innerHTML : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }
    var sections = sectionsToRender();

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(qty) || 1 }], sections: sections })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not add');
          return data;
        });
      })
      .then(function (added) {
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (added.sections && window.FoxTheme && FoxTheme.pubsub) {
              cart.sections = added.sections;
              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            }
          });
      })
      .catch(function (err) {
        console.error('[ps-cart-cro]', err);
        if (button) {
          button.textContent = /stock|available|quantity/i.test(err.message) ? 'Sold out' : 'Try again';
          setTimeout(function () {
            if (!button.isConnected) return;
            button.disabled = false;
            button.innerHTML = label;
          }, 2500);
        }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ps-cro-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    addToCart(btn.dataset.variantId, btn.dataset.qty, btn);
  });

  // "Complete your order" add-ons: replaces the old handler that reloaded the page.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target.closest && e.target.closest('.ps-cart-addon__form');
      if (!form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var id = form.querySelector('input[name="id"]');
      var qty = form.querySelector('input[name="quantity"]');
      addToCart(id && id.value, qty ? qty.value : 1, form.querySelector('button[type="submit"]'));
    },
    true
  );

  var drawer;
  var observer;

  function patch() {
    if (!drawer) return;
    if (observer) observer.disconnect();

    var summary = drawer.querySelector('[data-ps-cro-grand]');
    var label = drawer.querySelector('.ps-cart-checkout-btn__text');
    if (summary && label) {
      var text = 'Secure checkout · ' + summary.getAttribute('data-ps-cro-grand');
      if (label.textContent.trim() !== text) label.textContent = text;
    }

    drawer.querySelectorAll('.cart-item[data-quantity]').forEach(function (li) {
      var qty = parseInt(li.dataset.quantity, 10);
      var unit = parseInt(li.dataset.price, 10);
      var price = li.querySelector('.cart-item__prices .price');
      if (!price || price.dataset.psDone || qty < 2 || !unit) return;
      if (price.classList.contains('price--on-sale')) return;
      price.dataset.psDone = '1';
      price.innerHTML = money(unit * qty) + '<span class="ps-cro-each">' + money(unit) + ' each</span>';
    });

    if (observer) observer.observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    observer = new MutationObserver(patch);
    patch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
